/** author：胡枭 */

import { getUserCompanyInfoApi } from '@/api/company.js'

const state = {
  companyId: '', // 公司 ID
  companyName: '', // 公司名称
  logo: '', // 公司LOGO
  acronyms: '', // 公司简称
  isSupplier: '', // 是否为供应商 0: 否 1: 是
  isPurchaser: '', // 是否为采购人 0:否 1: 是
  isAgency: '', // 是否为代理机构 0: 否 1: 是
  isCertified: '', // 是否认证 0: 否 1: 是
  companyStatus: '', // 公司状态 0：禁用 1：正常
  supervise: false // 公司受到监管：true 公司未受监管：false
}

const mutations = {
  SET_COMPANY_ID: (state, id) => {
    state.companyId = id
  },
  SET_COMPANY_NAME: (state, companyName) => {
    state.companyName = companyName
  },
  SET_COMPANY_LOGO: (state, logo) => {
    state.logo = logo
  },
  SET_COMPANY_ACRONYMS: (state, acronyms) => {
    state.acronyms = acronyms
  },
  SET_COMPANY_IS_SUPPLIER: (state, isSupplier) => {
    state.isSupplier = isSupplier
  },
  SET_COMPANY_IS_PURCHASER: (state, isPurchaser) => {
    state.isPurchaser = isPurchaser
  },
  SET_COMPANY_IS_AGENCY: (state, isAgency) => {
    state.isAgency = isAgency
  },
  SET_COMPANY_IS_CERTIFIED: (state, isCertified) => {
    state.isCertified = isCertified
  },
  SET_COMPANY_STATUS: (state, status) => {
    state.companyStatus = status
  },
  SET_COMPANY_SUPERVISE: (state, supervise) => {
    state.supervise = supervise
  },

  // 联系人信息
  SET_CONTACT_NAME: (state, contactName) => {
    state.contactName = contactName
  },
  SET_CONTACT_TEL: (state, contactTel) => {
    state.contactTel = contactTel
  },
  SET_CONTACT_EMAIL: (state, contactEmail) => {
    state.contactEmail = contactEmail
  }
}

const actions = {
  getUserCompanyInfo({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      getUserCompanyInfoApi()
        .then(res => {
          commit('SET_COMPANY_ID', res.data.companyId)
          commit('SET_COMPANY_NAME', res.data.companyName)
          commit('SET_COMPANY_LOGO', res.data.companyInfo.logo)
          commit('SET_COMPANY_ACRONYMS', res.data.companyInfo.acronyms)
          commit('SET_COMPANY_IS_SUPPLIER', res.data.identityInfo.isSupplier)
          commit('SET_COMPANY_IS_PURCHASER', res.data.identityInfo.isPurchaser)
          commit('SET_COMPANY_IS_AGENCY', res.data.identityInfo.isAgency)
          commit('SET_COMPANY_IS_CERTIFIED', res.data.isCertified)
          commit('SET_COMPANY_STATUS', res.data.status)
          commit('SET_COMPANY_SUPERVISE', res.data.stateOwnedSupervise)

          resolve(res.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
